/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AbandonCustomCourseResponse } from '../models';
// @ts-ignore
import type { AnswerCustomCourseCheckBody } from '../models';
// @ts-ignore
import type { CreateCustomCourseBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetActiveCustomCourseResponse } from '../models';
// @ts-ignore
import type { GetAllMyCustomCoursesResponse } from '../models';
// @ts-ignore
import type { GetCustomCourseResponse } from '../models';
// @ts-ignore
import type { GetJobCourseResponse } from '../models';
// @ts-ignore
import type { GetJobRelatedCoursesResponse } from '../models';
// @ts-ignore
import type { UnlockCustomCourseLessonsResponse } from '../models';
/**
 * CustomCourseApiApi - axios parameter creator
 */
export const CustomCourseApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiAbandonCustomCourse: async (buildId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildId' is not null or undefined
            assertParamExists('customCourseApiAbandonCustomCourse', 'buildId', buildId)
            const localVarPath = `/custom-course/{build_id}/abandon`
                .replace('{build_id}', encodeURIComponent(String(buildId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} buildId 
         * @param {AnswerCustomCourseCheckBody} answerCustomCourseCheckBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiAnswerCustomCourseCheck: async (buildId: string, answerCustomCourseCheckBody: AnswerCustomCourseCheckBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildId' is not null or undefined
            assertParamExists('customCourseApiAnswerCustomCourseCheck', 'buildId', buildId)
            // verify required parameter 'answerCustomCourseCheckBody' is not null or undefined
            assertParamExists('customCourseApiAnswerCustomCourseCheck', 'answerCustomCourseCheckBody', answerCustomCourseCheckBody)
            const localVarPath = `/custom-course/{build_id}/answer`
                .replace('{build_id}', encodeURIComponent(String(buildId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(answerCustomCourseCheckBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiConfirmCustomCourse: async (buildId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildId' is not null or undefined
            assertParamExists('customCourseApiConfirmCustomCourse', 'buildId', buildId)
            const localVarPath = `/custom-course/{build_id}/confirm`
                .replace('{build_id}', encodeURIComponent(String(buildId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCustomCourseBody} createCustomCourseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiCreateCustomCourse: async (createCustomCourseBody: CreateCustomCourseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCustomCourseBody' is not null or undefined
            assertParamExists('customCourseApiCreateCustomCourse', 'createCustomCourseBody', createCustomCourseBody)
            const localVarPath = `/custom-course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomCourseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} [variant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiGenerateJobCourse: async (jobId: string, variant?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('customCourseApiGenerateJobCourse', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/course/generate`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (variant !== undefined) {
                localVarQueryParameter['variant'] = variant;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiGetActiveCustomCourse: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/custom-course/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiGetCustomCourse: async (buildId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildId' is not null or undefined
            assertParamExists('customCourseApiGetCustomCourse', 'buildId', buildId)
            const localVarPath = `/custom-course/{build_id}`
                .replace('{build_id}', encodeURIComponent(String(buildId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiGetJobCourse: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('customCourseApiGetJobCourse', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/course`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiGetJobRelatedCourses: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('customCourseApiGetJobRelatedCourses', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/course/related`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiListMyCustomCourses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/custom-courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiUnlockCustomCourseLessons: async (buildId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildId' is not null or undefined
            assertParamExists('customCourseApiUnlockCustomCourseLessons', 'buildId', buildId)
            const localVarPath = `/custom-course/{build_id}/unlock-lessons`
                .replace('{build_id}', encodeURIComponent(String(buildId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomCourseApiApi - functional programming interface
 */
export const CustomCourseApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomCourseApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customCourseApiAbandonCustomCourse(buildId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbandonCustomCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customCourseApiAbandonCustomCourse(buildId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomCourseApiApi.customCourseApiAbandonCustomCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} buildId 
         * @param {AnswerCustomCourseCheckBody} answerCustomCourseCheckBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customCourseApiAnswerCustomCourseCheck(buildId: string, answerCustomCourseCheckBody: AnswerCustomCourseCheckBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customCourseApiAnswerCustomCourseCheck(buildId, answerCustomCourseCheckBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomCourseApiApi.customCourseApiAnswerCustomCourseCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customCourseApiConfirmCustomCourse(buildId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customCourseApiConfirmCustomCourse(buildId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomCourseApiApi.customCourseApiConfirmCustomCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCustomCourseBody} createCustomCourseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customCourseApiCreateCustomCourse(createCustomCourseBody: CreateCustomCourseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customCourseApiCreateCustomCourse(createCustomCourseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomCourseApiApi.customCourseApiCreateCustomCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} [variant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customCourseApiGenerateJobCourse(jobId: string, variant?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customCourseApiGenerateJobCourse(jobId, variant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomCourseApiApi.customCourseApiGenerateJobCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customCourseApiGetActiveCustomCourse(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActiveCustomCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customCourseApiGetActiveCustomCourse(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomCourseApiApi.customCourseApiGetActiveCustomCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customCourseApiGetCustomCourse(buildId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customCourseApiGetCustomCourse(buildId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomCourseApiApi.customCourseApiGetCustomCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customCourseApiGetJobCourse(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customCourseApiGetJobCourse(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomCourseApiApi.customCourseApiGetJobCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customCourseApiGetJobRelatedCourses(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobRelatedCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customCourseApiGetJobRelatedCourses(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomCourseApiApi.customCourseApiGetJobRelatedCourses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customCourseApiListMyCustomCourses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllMyCustomCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customCourseApiListMyCustomCourses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomCourseApiApi.customCourseApiListMyCustomCourses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} buildId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customCourseApiUnlockCustomCourseLessons(buildId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnlockCustomCourseLessonsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customCourseApiUnlockCustomCourseLessons(buildId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomCourseApiApi.customCourseApiUnlockCustomCourseLessons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomCourseApiApi - factory interface
 */
export const CustomCourseApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomCourseApiApiFp(configuration)
    return {
        /**
         * 
         * @param {CustomCourseApiApiCustomCourseApiAbandonCustomCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiAbandonCustomCourse(requestParameters: CustomCourseApiApiCustomCourseApiAbandonCustomCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<AbandonCustomCourseResponse> {
            return localVarFp.customCourseApiAbandonCustomCourse(requestParameters.buildId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomCourseApiApiCustomCourseApiAnswerCustomCourseCheckRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiAnswerCustomCourseCheck(requestParameters: CustomCourseApiApiCustomCourseApiAnswerCustomCourseCheckRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCustomCourseResponse> {
            return localVarFp.customCourseApiAnswerCustomCourseCheck(requestParameters.buildId, requestParameters.answerCustomCourseCheckBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomCourseApiApiCustomCourseApiConfirmCustomCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiConfirmCustomCourse(requestParameters: CustomCourseApiApiCustomCourseApiConfirmCustomCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCustomCourseResponse> {
            return localVarFp.customCourseApiConfirmCustomCourse(requestParameters.buildId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomCourseApiApiCustomCourseApiCreateCustomCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiCreateCustomCourse(requestParameters: CustomCourseApiApiCustomCourseApiCreateCustomCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCustomCourseResponse> {
            return localVarFp.customCourseApiCreateCustomCourse(requestParameters.createCustomCourseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomCourseApiApiCustomCourseApiGenerateJobCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiGenerateJobCourse(requestParameters: CustomCourseApiApiCustomCourseApiGenerateJobCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetJobCourseResponse> {
            return localVarFp.customCourseApiGenerateJobCourse(requestParameters.jobId, requestParameters.variant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiGetActiveCustomCourse(options?: RawAxiosRequestConfig): AxiosPromise<GetActiveCustomCourseResponse> {
            return localVarFp.customCourseApiGetActiveCustomCourse(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomCourseApiApiCustomCourseApiGetCustomCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiGetCustomCourse(requestParameters: CustomCourseApiApiCustomCourseApiGetCustomCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCustomCourseResponse> {
            return localVarFp.customCourseApiGetCustomCourse(requestParameters.buildId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomCourseApiApiCustomCourseApiGetJobCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiGetJobCourse(requestParameters: CustomCourseApiApiCustomCourseApiGetJobCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetJobCourseResponse> {
            return localVarFp.customCourseApiGetJobCourse(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomCourseApiApiCustomCourseApiGetJobRelatedCoursesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiGetJobRelatedCourses(requestParameters: CustomCourseApiApiCustomCourseApiGetJobRelatedCoursesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetJobRelatedCoursesResponse> {
            return localVarFp.customCourseApiGetJobRelatedCourses(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiListMyCustomCourses(options?: RawAxiosRequestConfig): AxiosPromise<GetAllMyCustomCoursesResponse> {
            return localVarFp.customCourseApiListMyCustomCourses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomCourseApiApiCustomCourseApiUnlockCustomCourseLessonsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customCourseApiUnlockCustomCourseLessons(requestParameters: CustomCourseApiApiCustomCourseApiUnlockCustomCourseLessonsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnlockCustomCourseLessonsResponse> {
            return localVarFp.customCourseApiUnlockCustomCourseLessons(requestParameters.buildId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for customCourseApiAbandonCustomCourse operation in CustomCourseApiApi.
 */
export interface CustomCourseApiApiCustomCourseApiAbandonCustomCourseRequest {
    readonly buildId: string
}

/**
 * Request parameters for customCourseApiAnswerCustomCourseCheck operation in CustomCourseApiApi.
 */
export interface CustomCourseApiApiCustomCourseApiAnswerCustomCourseCheckRequest {
    readonly buildId: string

    readonly answerCustomCourseCheckBody: AnswerCustomCourseCheckBody
}

/**
 * Request parameters for customCourseApiConfirmCustomCourse operation in CustomCourseApiApi.
 */
export interface CustomCourseApiApiCustomCourseApiConfirmCustomCourseRequest {
    readonly buildId: string
}

/**
 * Request parameters for customCourseApiCreateCustomCourse operation in CustomCourseApiApi.
 */
export interface CustomCourseApiApiCustomCourseApiCreateCustomCourseRequest {
    readonly createCustomCourseBody: CreateCustomCourseBody
}

/**
 * Request parameters for customCourseApiGenerateJobCourse operation in CustomCourseApiApi.
 */
export interface CustomCourseApiApiCustomCourseApiGenerateJobCourseRequest {
    readonly jobId: string

    readonly variant?: string
}

/**
 * Request parameters for customCourseApiGetCustomCourse operation in CustomCourseApiApi.
 */
export interface CustomCourseApiApiCustomCourseApiGetCustomCourseRequest {
    readonly buildId: string
}

/**
 * Request parameters for customCourseApiGetJobCourse operation in CustomCourseApiApi.
 */
export interface CustomCourseApiApiCustomCourseApiGetJobCourseRequest {
    readonly jobId: string
}

/**
 * Request parameters for customCourseApiGetJobRelatedCourses operation in CustomCourseApiApi.
 */
export interface CustomCourseApiApiCustomCourseApiGetJobRelatedCoursesRequest {
    readonly jobId: string
}

/**
 * Request parameters for customCourseApiUnlockCustomCourseLessons operation in CustomCourseApiApi.
 */
export interface CustomCourseApiApiCustomCourseApiUnlockCustomCourseLessonsRequest {
    readonly buildId: string
}

/**
 * CustomCourseApiApi - object-oriented interface
 */
export class CustomCourseApiApi extends BaseAPI {
    /**
     * 
     * @param {CustomCourseApiApiCustomCourseApiAbandonCustomCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customCourseApiAbandonCustomCourse(requestParameters: CustomCourseApiApiCustomCourseApiAbandonCustomCourseRequest, options?: RawAxiosRequestConfig) {
        return CustomCourseApiApiFp(this.configuration).customCourseApiAbandonCustomCourse(requestParameters.buildId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomCourseApiApiCustomCourseApiAnswerCustomCourseCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customCourseApiAnswerCustomCourseCheck(requestParameters: CustomCourseApiApiCustomCourseApiAnswerCustomCourseCheckRequest, options?: RawAxiosRequestConfig) {
        return CustomCourseApiApiFp(this.configuration).customCourseApiAnswerCustomCourseCheck(requestParameters.buildId, requestParameters.answerCustomCourseCheckBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomCourseApiApiCustomCourseApiConfirmCustomCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customCourseApiConfirmCustomCourse(requestParameters: CustomCourseApiApiCustomCourseApiConfirmCustomCourseRequest, options?: RawAxiosRequestConfig) {
        return CustomCourseApiApiFp(this.configuration).customCourseApiConfirmCustomCourse(requestParameters.buildId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomCourseApiApiCustomCourseApiCreateCustomCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customCourseApiCreateCustomCourse(requestParameters: CustomCourseApiApiCustomCourseApiCreateCustomCourseRequest, options?: RawAxiosRequestConfig) {
        return CustomCourseApiApiFp(this.configuration).customCourseApiCreateCustomCourse(requestParameters.createCustomCourseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomCourseApiApiCustomCourseApiGenerateJobCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customCourseApiGenerateJobCourse(requestParameters: CustomCourseApiApiCustomCourseApiGenerateJobCourseRequest, options?: RawAxiosRequestConfig) {
        return CustomCourseApiApiFp(this.configuration).customCourseApiGenerateJobCourse(requestParameters.jobId, requestParameters.variant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customCourseApiGetActiveCustomCourse(options?: RawAxiosRequestConfig) {
        return CustomCourseApiApiFp(this.configuration).customCourseApiGetActiveCustomCourse(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomCourseApiApiCustomCourseApiGetCustomCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customCourseApiGetCustomCourse(requestParameters: CustomCourseApiApiCustomCourseApiGetCustomCourseRequest, options?: RawAxiosRequestConfig) {
        return CustomCourseApiApiFp(this.configuration).customCourseApiGetCustomCourse(requestParameters.buildId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomCourseApiApiCustomCourseApiGetJobCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customCourseApiGetJobCourse(requestParameters: CustomCourseApiApiCustomCourseApiGetJobCourseRequest, options?: RawAxiosRequestConfig) {
        return CustomCourseApiApiFp(this.configuration).customCourseApiGetJobCourse(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomCourseApiApiCustomCourseApiGetJobRelatedCoursesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customCourseApiGetJobRelatedCourses(requestParameters: CustomCourseApiApiCustomCourseApiGetJobRelatedCoursesRequest, options?: RawAxiosRequestConfig) {
        return CustomCourseApiApiFp(this.configuration).customCourseApiGetJobRelatedCourses(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customCourseApiListMyCustomCourses(options?: RawAxiosRequestConfig) {
        return CustomCourseApiApiFp(this.configuration).customCourseApiListMyCustomCourses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomCourseApiApiCustomCourseApiUnlockCustomCourseLessonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customCourseApiUnlockCustomCourseLessons(requestParameters: CustomCourseApiApiCustomCourseApiUnlockCustomCourseLessonsRequest, options?: RawAxiosRequestConfig) {
        return CustomCourseApiApiFp(this.configuration).customCourseApiUnlockCustomCourseLessons(requestParameters.buildId, options).then((request) => request(this.axios, this.basePath));
    }
}

